export default {
    100: {
        damage: 26,
        firerate: 40,
        accuracy: 40,
        range: 25,
        ammo: 12
    },
    101: {
        damage: 27,
        firerate: 40,
        accuracy: 50,
        range: 30,
        ammo: 12
    },
    102: {
        damage: 51,
        firerate: 40,
        accuracy: 55,
        range: 35,
        ammo: 6 
    },
    103: {
        damage: 30,
        firerate: 40,
        accuracy: 40,
        range: 20,
        ammo: 6 
    },
    104: {
        damage: 40,
        firerate: 40,
        accuracy: 50,
        range: 35,
        ammo: 18
    },
    105: {
        damage: 35,
        firerate: 40,
        accuracy: 40,
        range: 25,
        ammo: 7
    },
    106: {
        damage: 80,
        firerate: 15,
        accuracy: 30,
        range: 35,
        ammo: 1
    },
    107: {
        damage: 70,
        firerate: 20,
        accuracy: 65,
        range: 35,
        ammo: 6
    },
    108: {
        damage: 26,
        firerate: 80,
        accuracy: 35,
        range: 30,
        ammo: 18
    },
    109: {
        damage: 1,
        firerate: 10,
        accuracy: 40,
        range: 5,
        ammo: 0
    },
    110: {
        damage: 20,
        firerate: 10,
        accuracy: 30,
        range: 10,
        ammo: 1
    },
    111: {
        damage: 70,
        firerate: 35,
        accuracy: 65,
        range: 20,
        ammo: 6
    },
    112: {
        damage: 38,
        firerate: 40,
        accuracy: 40,
        range: 25,
        ammo: 12
    },
    113: {
        damage: 30,
        firerate: 40,
        accuracy: 40,
        range: 20,
        ammo: 6
    },
    114: {
        damage: 75,
        firerate: 30,
        accuracy: 65,
        range: 35,
        ammo: 6
    },
    115: {
        damage: 21,
        firerate: 60,
        accuracy: 30,
        range: 25,
        ammo: 16
    },
    116: {
        damage: 28,
        firerate: 70,
        accuracy: 40,
        range: 30,
        ammo: 12
    },
    117: {
        damage: 22,
        firerate: 55,
        accuracy: 40,
        range: 35,
        ammo: 30
    },
    118: {
        damage: 23,
        firerate: 55,
        accuracy: 45,
        range: 40,
        ammo: 30
    },
    119: {
        damage: 25,
        firerate: 50,
        accuracy: 45,
        range: 38,
        ammo: 30 
    },
    120: {
        damage: 50,
        firerate: 60,
        accuracy: 40,
        range: 60,
        ammo: 54
    },
    121: {
        damage: 55,
        firerate: 65,
        accuracy: 45,
        range: 60,
        ammo: 100
    },
    122: {
        damage: 34,
        firerate: 65,
        accuracy: 38,
        range: 56,
        ammo: 30
    },
    123: {
        damage: 22,
        firerate: 84,
        accuracy: 33,
        range: 30,
        ammo: 20
    },
    124: {
        damage: 22,
        firerate: 55,
        accuracy: 40,
        range: 35,
        ammo: 30
    },
    125: {
        damage: 57,
        firerate: 65,
        accuracy: 45,
        range: 60,
        ammo: 100
    },
    126: {
        damage: 30,
        firerate: 60,
        accuracy: 45,
        range: 45,
        ammo: 30
    },
    127: {
        damage: 32,
        firerate: 65,
        accuracy: 55,
        range: 45,
        ammo: 30
    },
    128: {
        damage: 34,
        firerate: 70,
        accuracy: 50,
        range: 45,
        ammo: 30
    },
    129: {
        damage: 34,
        firerate: 65,
        accuracy: 55,
        range: 40,
        ammo: 30
    },
    130: {
        damage: 32,
        firerate: 70,
        accuracy: 45,
        range: 45,
        ammo: 30
    },
    131: {
        damage: 36,
        firerate: 60,
        accuracy: 35,
        range: 45,
        ammo: 30
    },
    132: {
        damage: 35,
        firerate: 60,
        accuracy: 45,
        range: 45,
        ammo: 30
    },
    133: {
        damage: 36,
        firerate: 65,
        accuracy: 55,
        range: 45,
        ammo: 30
    },
    134: {
        damage: 34,
        firerate: 65,
        accuracy: 55,
        range: 40,
        ammo: 30
    },
    135: {
        damage: 35,
        firerate: 72,
        accuracy: 45,
        range: 45,
        ammo: 30
    },
    136: {
        damage: 96,
        firerate: 25,
        accuracy: 70,
        range: 95,
        ammo: 10
    },
    137: {
        damage: 98,
        firerate: 20,
        accuracy: 90,
        range: 100,
        ammo: 5
    },
    138: {
        damage: 70,
        firerate: 40,
        accuracy: 80,
        range: 90,
        ammo: 8
    },
    139: {
        damage: 98,
        firerate: 20,
        accuracy: 90,
        range: 100,
        ammo: 6
    },
    140: {
        damage: 70,
        firerate: 40,
        accuracy: 80,
        range: 90,
        ammo: 8
    },
    141: {
        damage: 67,
        firerate: 20,
        accuracy: 30,
        range: 20,
        ammo: 8
    },
    142: {
        damage: 96,
        firerate: 20,
        accuracy: 20,
        range: 15,
        ammo: 8
    },
    143: {
        damage: 67,
        firerate: 20,
        accuracy: 30,
        range: 20,
        ammo: 14
    },
    144: {
        damage: 77,
        firerate: 50,
        accuracy: 25,
        range: 15,
        ammo: 8
    },
    145: {
        damage: 97,
        firerate: 10,
        accuracy: 65,
        range: 85,
        ammo: 1
    },
    146: {
        damage: 85,
        firerate: 45,
        accuracy: 30,
        range: 25,
        ammo: 6
    },
    147: {
        damage: 98,
        firerate: 25,
        accuracy: 15,
        range: 10,
        ammo: 2
    },
    148: {
        damage: 70,
        firerate: 45,
        accuracy: 22,
        range: 20,
        ammo: 10
    },
    149: {
        damage: 67,
        firerate: 20,
        accuracy: 30,
        range: 20,
        ammo: 8
    },
    150: {
        damage: 80,
        firerate: 10,
        accuracy: 10,
        range: 50,
        ammo: 0
    },
    151: {
        damage: 32,
        firerate: 44,
        accuracy: 35,
        range: 20,
        ammo: 12
    },
    152: {
        damage: 70,
        firerate: 25,
        accuracy: 60,
        range: 35,
        ammo: 6
    },
    153: {
        damage: 55,
        firerate: 65,
        accuracy: 45,
        range: 60,
        ammo: 9999
    },
    154: {
        damage: 95,
        firerate: 20,
        accuracy: 10,
        range: 50,
        ammo: 10
    },
    155: {
        damage: 100,
        firerate: 5,
        accuracy: 10,
        range: 70,
        ammo: 1
    },
    156: {
        damage: 30,
        firerate: 100,
        accuracy: 40,
        range: 55,
        ammo: 595
    },
    157: {
        damage: 45,
        firerate: 5,
        accuracy: 12,
        range: 60,
        ammo: 1
    },
    158: {
        damage: 90,
        firerate: 25,
        accuracy: 20,
        range: 70,
        ammo: 20
    },
    159: {
        damage: 95,
        firerate: 5,
        accuracy: 25,
        range: 75,
        ammo: 1
    },
    160: {
        damage: 0,
        firerate: 20,
        accuracy: 10,
        range: 50,
        ammo: 10
    },
    161: {
        damage: 95,
        firerate: 10,
        accuracy: 15,
        range: 55,
        ammo: 1
    },
    162: {
        damage: 30,
        firerate: 100,
        accuracy: 40,
        range: 55,
        ammo: 9999
    },
    180: {
        damage: 15,
        firerate: 20,
        accuracy: 0,
        range: 1,
        ammo: 0
    },
    181: {
        damage: 10,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    },  
    182: {
        damage: 10,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    183: {
        damage: 20,
        firerate: 10,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    184: {
        damage: 10,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    185: {
        damage: 20,
        firerate: 10,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    186: {
        damage: 20,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    187: {
        damage: 20,
        firerate: 20,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    188: {
        damage: 15,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    189: {
        damage: 10,
        firerate: 20,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    190: {
        damage: 10,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    191: {
        damage: 15,
        firerate: 20,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    192: {
        damage: 15,
        firerate: 20,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    193: {
        damage: 20,
        firerate: 10,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    194: {
        damage: 10,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
    195: {
        damage: 15,
        firerate: 15,
        accuracy: 0,
        range: 1,
        ammo: 0
    }, 
}
